export const siteCategories = {
    "61fd57f2eaf885feb968aa9f": {
        "label": "Manage Your Restaurant",
        "categoryPageUrl": "/categories/manage-your-restaurant"
    },
    "61fd586eeaf885feb968aaa6": {
        "label": "Manage Your Restaurant on Home Page",
        "categoryPageUrl": "/categories/home-page-manage",
    },
    "61fd5811eaf885feb968aaa0": {
        "label": "Promote Your Business",
        "categoryPageUrl": "/categories/promote-your-business",
    },
    "61fd588ceaf885feb968aaa7": {
        "label": "Promote Your Business on Home Page",
        "categoryPageUrl": "/categories/home-page-promote",
    },
    "61fd57d7eaf885feb968aa9e": {
        "label": "Create Your Menu",
        "categoryPageUrl": "/categories/create-your-menu",
    },
    "61fd5854eaf885feb968aaa5": {
        "label": "Create Your Menu on Home Page",
        "categoryPageUrl": "/categories/home-page-menu",
    },
    "61fd58b0eaf885feb968aaae": {
        "label": "Home Main Posts",
        "categoryPageUrl": "/categories/home-main-posts",
    },
    "61fd589deaf885feb968aaac": {
        "label": "Main Feature Post",
        "categoryPageUrl": "/categories/main-feature-post",
    },
    "61fd58a6eaf885feb968aaad": {
        "label": "Secondary Feature Post",
        "categoryPageUrl": "/categories/secondary-feature-post",
    },
    "61fd58b7eaf885feb968aaaf": {
        "label": "Most Popular",
        "categoryPageUrl": "/categories/most-popular",
    },
    "61fd58c3eaf885feb968aab0": {
        "label": "Must Read",
        "categoryPageUrl": "/categories/must-read",
    },
}

export const categoryPath = '/explore/category/';